import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { X } from "@phosphor-icons/react";

export const formatMac = (v) => {
  const raw = v.toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, 12);
  return raw.match(/.{1,2}/g)?.join(":") ?? "";
};

export const parseQr = (text) => {
  text = text.trim();
  try {
    const u = new URL(/^https?:\/\//i.test(text) ? text : `https://${text}`);
    const key = u.searchParams.get("key") || u.searchParams.get("device_key");
    const mac = u.searchParams.get("mac");
    if (key || mac) return { key: key || "", mac: mac || "" };
  } catch {}
  try {
    const j = JSON.parse(text);
    if (j.key || j.device_key || j.mac) return { key: j.key || j.device_key || "", mac: j.mac || "" };
  } catch {}
  const mac = text.match(/([0-9A-Za-z]{2}[:-]){5}[0-9A-Za-z]{2}/)?.[0] || "";
  const key = text.replace(mac, "").match(/\b[0-9A-Za-z]{6}\b/)?.[0] || "";
  return key || mac ? { key, mac } : null;
};

export const QrScanner = ({ onResult, onClose }) => {
  const ref = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const qr = new Html5Qrcode("qr-reader", { verbose: false });
    ref.current = qr;
    let done = false;
    qr.start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 240, height: 240 } }, (text) => {
      if (done) return;
      const r = parseQr(text);
      if (!r) return setError("Ovaj QR kod ne sadrži Device Key i MAC adresu.");
      done = true;
      onResult(r);
    }).catch(() => setError("Kamera nije dostupna. Dozvolite pristup kameri u pregledaču ili unesite podatke ručno."));
    return () => { if (qr.isScanning) qr.stop().then(() => qr.clear()).catch(() => {}); };
  }, [onResult]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-black/90 p-5 backdrop-blur" data-testid="qr-scanner">
      <button onClick={onClose} className="absolute right-4 top-4 rounded-full border border-lineStrong p-2 text-white" data-testid="qr-scanner-close"><X size={20} /></button>
      <p className="text-center text-base font-bold">Skenirajte QR kod sa TV ekrana</p>
      <p className="max-w-xs text-center text-xs text-txt2">Uperite kameru telefona u QR kod koji prikazuje BalkanHD Play aplikacija na TV-u.</p>
      <div id="qr-reader" className="w-full max-w-[340px] overflow-hidden rounded-2xl border-2 border-brand bg-black" />
      {error && <p className="max-w-xs text-center text-xs font-medium text-err" data-testid="qr-scanner-error">{error}</p>}
    </div>
  );
};
